import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ApertureProps extends HTMLAttributes<HTMLDivElement> {
  ticks?: boolean;
  label?: ReactNode;
  labelEnd?: boolean;
  rv?: string;
}

// Frame within frame: a hairline inset frame, optional corner ticks, and a Mono label that
// interrupts the top line — the one element allowed to break the frame.
export default function Aperture({ ticks, label, labelEnd, rv, className, children, ...rest }: ApertureProps) {
  return (
    <div className={cn('ap', ticks && 'ap--ticks', className)} data-rv={rv} {...rest}>
      {label && <span className={cn('ap__label mono', labelEnd && 'ap__label--end')}>{label}</span>}
      {children}
    </div>
  );
}
